import { render, staticRenderFns } from "./TicketSupport.vue?vue&type=template&id=f8a18d76&scoped=true&"
import script from "./TicketSupport.vue?vue&type=script&lang=js&"
export * from "./TicketSupport.vue?vue&type=script&lang=js&"
import style0 from "./TicketSupport.vue?vue&type=style&index=0&id=f8a18d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a18d76",
  null
  
)

export default component.exports